'use client';

import { c as _c } from "react/compiler-runtime";
import cn from 'clsx';
import { usePathname } from 'next/navigation';
import { useImperativeHandle, useRef, useState } from 'react';
import { Marquee } from '~/components/marquee';
import { useGlobalTransitionRefs } from '~/components/page-transition/context';
import { BANNER_TEXT } from '~/libs/constants';
import s from './banner.module.css';
const visiblePages = ['/work', '/store', '/contact', '/about', '/read'];
export function Banner() {
  const $ = _c(8);
  const pathname = usePathname();
  const [speed, setSpeed] = useState(1);
  const bannerRef = useRef(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => ({
      setSpeed: speed_0 => {
        setSpeed(speed_0);
      }
    });
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useImperativeHandle(bannerRef, t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      banner: bannerRef
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  useGlobalTransitionRefs(t1);
  if (!visiblePages.includes(pathname)) {
    return null;
  }
  const text = BANNER_TEXT[pathname] || "";
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = cn(s.container, "absolute left-0 top-0 sh-74 dt:sh-154 w-full mt-header-height grid place-items-center banner max-w-screen overflow-hidden spt-6 dt:spt-18");
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = `${text} `;
  let t4;
  if ($[3] !== t3) {
    t4 = <span className="inline-block smr-56 dt:smr-216">{t3}</span>;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== speed || $[6] !== t4) {
    t5 = <div id="banner" className={t2}><Marquee id="marquee" repeat={10} speed={speed} className="px-safe" startFromZero={true}>{t4}</Marquee></div>;
    $[5] = speed;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
}